export const wardAssignByMapping = {
  ADM: 'Admission Officer',
  MAP: 'Mapping',
  BEDCO: 'Bed Coordinator',
};

export const redirOptAtWardAckList = [
  {
    text: 'Next assigned ward(if applicable)',
    value: 'NEXT',
  },
  {
    text: 'Admission Officer',
    value: 'ADM',
  },
  {
    text: 'Specialty Bed Co. of the case',
    value: 'BEDCO',
  },
  {
    text: 'Any wards',
    value: 'ANY',
  },
  {
    text: 'Wards of this specialty only',
    value: 'SPECIALTY_ONLY',
  },
];

export const specialtyMapping = [
  {
    text: 'Expected admission specialty',
    value: 'exp_admit_specialty',
  },
  {
    text: `Admit to ward's specialty`,
    value: 'admit_specialty',
  },
];

export const subSpecialtyMapping = [
  {
    text: 'left textbox',
    value: 'admit_ward',
  },
  {
    text: `right textbox`,
    value: 'admit_specialty_others',
  },
  {
    text: 'NA',
    value: 'na',
  },
  {
    text: `Admit to ward's specialty`,
    value: 'admit_specialty',
  },
];
